export var StatusTypes = /*#__PURE__*/function (StatusTypes) {
  StatusTypes["SUCCESS"] = "SUCCESS";
  StatusTypes["ERROR"] = "ERROR";
  StatusTypes["PENDING"] = "PENDING";
  StatusTypes["INFO"] = "INFO";
  StatusTypes["EMPTY"] = "EMPTY";
  return StatusTypes;
}({});
export var UserAddressCommandNames = /*#__PURE__*/function (UserAddressCommandNames) {
  UserAddressCommandNames["VERIFY_ADDRESS"] = "VERIFY_ADDRESS";
  UserAddressCommandNames["ADDRESS_UPDATE"] = "ADDRESS_UPDATE";
  UserAddressCommandNames["UA_PROGRESS_STATUS"] = "UA_PROGRESS_STATUS";
  UserAddressCommandNames["SAVE_CONFIGS"] = "SAVE_CONFIGS";
  return UserAddressCommandNames;
}({});
export var PaymentMethodsCommandNames = /*#__PURE__*/function (PaymentMethodsCommandNames) {
  PaymentMethodsCommandNames["RECAPTCHA_VERIFIED"] = "RECAPTCHA_VERIFIED";
  PaymentMethodsCommandNames["FETCH_PAYMENT_METHOD"] = "FETCH_PAYMENT_METHOD";
  PaymentMethodsCommandNames["FETCH_PAYMENT_METHOD_ENABLED"] = "FETCH_PAYMENT_METHOD_ENABLED";
  PaymentMethodsCommandNames["FETCH_PAYMENT_METHOD_DISABLED"] = "FETCH_PAYMENT_METHOD_DISABLED";
  PaymentMethodsCommandNames["MOP_SELECTED"] = "MOP_SELECTED";
  PaymentMethodsCommandNames["RESET_FIELDS"] = "RESET_FIELDS";
  PaymentMethodsCommandNames["SELECTED_MOP_VIEW"] = "SELECTED_MOP_VIEW";
  PaymentMethodsCommandNames["PAYMENT_FORM_INITIALIZED"] = "PAYMENT_FORM_INITIALIZED";
  PaymentMethodsCommandNames["OPEN_BILLDESK"] = "OPEN_BILLDESK";
  return PaymentMethodsCommandNames;
}({});
export var DropInPaymentsCommandNames = /*#__PURE__*/function (DropInPaymentsCommandNames) {
  DropInPaymentsCommandNames["PLACE_ORDER_DISABLED"] = "PLACE_ORDER_DISABLED";
  DropInPaymentsCommandNames["PLACE_ORDER_ENABLED"] = "PLACE_ORDER_ENABLED";
  DropInPaymentsCommandNames["UNKNOWN_COMMAND"] = "UNKNOWN_COMMAND";
  DropInPaymentsCommandNames["PLACE_ORDER_THROUGH_SDK"] = "PLACE_ORDER_THROUGH_SDK";
  DropInPaymentsCommandNames["UPDATE_HOST_ANNOTATIONS"] = "UPDATE_HOST_ANNOTATIONS";
  DropInPaymentsCommandNames["ADD_COUPON"] = "ADD_COUPON";
  DropInPaymentsCommandNames["REMOVE_COUPON"] = "REMOVE_COUPON";
  DropInPaymentsCommandNames["PLACE_ORDER"] = "PLACE_ORDER";
  DropInPaymentsCommandNames["ADD_ITEM"] = "ADD_ITEM";
  DropInPaymentsCommandNames["HISTORY_BACK_CLICK"] = "HISTORY_BACK_CLICK";
  DropInPaymentsCommandNames["REVIEW_VIEW"] = "REVIEW_VIEW";
  DropInPaymentsCommandNames["REPLACE_ITEM"] = "REPLACE_ITEM";
  DropInPaymentsCommandNames["BILLDESK_RESPONSE_HANDLER"] = "BILLDESK_RESPONSE_HANDLER";
  return DropInPaymentsCommandNames;
}({});
export var OneClickCommandNames = /*#__PURE__*/function (OneClickCommandNames) {
  OneClickCommandNames["RESUME_ORDER"] = "RESUME_ORDER";
  OneClickCommandNames["RESTART_ORDER"] = "RESTART_ORDER";
  OneClickCommandNames["EXIT_ONE_CLICK"] = "EXIT_ONE_CLICK";
  return OneClickCommandNames;
}({});
export var InterstitialCommandNames = /*#__PURE__*/function (InterstitialCommandNames) {
  InterstitialCommandNames["MULTI_MONTH_PLAN_SELECTED"] = "MULTI_MONTH_PLAN_SELECTED";
  InterstitialCommandNames["STANDARD_PLAN_SELECTED"] = "STANDARD_PLAN_SELECTED";
  InterstitialCommandNames["MULTI_MONTH_SWITCH_VARIATION"] = "MULTI_MONTH_SWITCH_VARIATION";
  return InterstitialCommandNames;
}({});
export var SharedCommandNames = /*#__PURE__*/function (SharedCommandNames) {
  SharedCommandNames["INITIALIZE"] = "INITIALIZE";
  SharedCommandNames["AUTHORIZE"] = "AUTHORIZE";
  SharedCommandNames["REAUTHORIZE"] = "REAUTHORIZE";
  SharedCommandNames["UPDATE_PRICING"] = "UPDATE_PRICING";
  SharedCommandNames["UNKNOWN_CALLBACK"] = "UNKNOWN_CALLBACK";
  SharedCommandNames["APP_MODE_CHANGED"] = "APP_MODE_CHANGED";
  return SharedCommandNames;
}({});
export var Component = /*#__PURE__*/function (Component) {
  Component["COUPON"] = "COUPON";
  Component["ONE_CLICK"] = "ONE_CLICK";
  Component["ORDER_MANAGEMENT"] = "ORDER_MANAGEMENT";
  Component["CART_CHECKOUT"] = "CART_CHECKOUT";
  Component["APP_MODULE_LOGIC"] = "APP_MODULE_LOGIC";
  Component["APP"] = "APP";
  Component["ZIPCODE"] = "ZIPCODE";
  Component["CITY_SELECTED"] = "CITY_SELECTED";
  Component["COUNTRY_SELECTED"] = "COUNTRY_SELECTED";
  Component["EXECUTE_COMMAND_LOGIC"] = "EXECUTE_COMMAND_LOGIC";
  Component["SELECTED_CITY_LOGIC"] = "SELECTED_CITY_LOGIC";
  Component["PAYMENT_METHODS_CALLBACK"] = "PAYMENT_METHODS_CALLBACK";
  Component["COMMAND_MANAGER"] = "COMMAND_MANAGER";
  return Component;
}({});
export var CallbackTypes = /*#__PURE__*/function (CallbackTypes) {
  CallbackTypes["LOG_EVENT"] = "LOG_EVENT";
  CallbackTypes["STATUS_UPDATE"] = "STATUS_UPDATE";
  return CallbackTypes;
}({});
export var ErrorType = /*#__PURE__*/function (ErrorType) {
  ErrorType["SERVER"] = "server";
  ErrorType["AUTHORIZATION"] = "auth";
  ErrorType["INLINE"] = "inline";
  return ErrorType;
}({});
export var ContextType = /*#__PURE__*/function (ContextType) {
  ContextType["DROP_IN_PAYMENTS"] = "DROP_IN_PAYMENTS";
  return ContextType;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/CallbackUtils/constants.js
// module id = 381
// module chunks = 11